export const REGEX =  {
  password: /^.{6,100}$/
}
